export default "__VITE_ASSET__IZUXGbqX__"